export const signInWithLinkedIn = () => {
  window.location.href = SETTINGS.LINKEDIN_LOGIN_URL + window.location.search;
};
